module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#B897FF","theme_color":"#B897FF","display":"minimal-ui","icon":"src/images/yuristrap-icon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"7ab72b048742bf5caed812ebd7c3d616"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
